(function() {
	'use strict';

	angular
		.module('assetCommon')
		.factory('fileUploadManager', fileUploadManager);

	function fileUploadManager($q, $log, assetService, fileUploadService, cancellationService, promiseUtilityService, _) {
		var log = $log.getLogger('fileUploadManager');

		function createProgressTracker() {
			var statusList = ['preparing', 'uploading', 'complete', 'error'];
			var files = {};
			var deferred = $q.defer();

			function getFileProgressReport(file) {
				return _.clone(file);
			}

			function getProgressReport() {
				var statusGroups = _.groupBy(files, 'status');
				var minStatus = _.find(statusList, function (status) { return statusGroups[status] && statusGroups[status].length; });
				var fileReports = _.map(files, getFileProgressReport);

				return {
					files: fileReports,
					status: minStatus
				};
			}

			var updateProgressSoon = _.throttle(function () {
				deferred.notify(getProgressReport());
			}, 100);

			return {
				addFile: function (fileId, fileSize) {
					files[fileId] = {
						id: fileId,
						status: statusList[0],
						fileSize: fileSize,
						uploadedSize: 0.0
					};
				},
				setFileStatus: function (fileId, status) {
					var file = files[fileId];
					file.status = status;

					if (status === 'error')
						file.uploadedSize = file.fileSize;

					updateProgressSoon();
				},
				setUploadProgress: function (fileId, uploadedSize, fileSize) {
					if (!_.isUndefined(fileSize))
						files[fileId].fileSize = Math.max(fileSize, 0.01);

					files[fileId].uploadedSize = Math.min(uploadedSize, files[fileId].fileSize);

					updateProgressSoon();
				},
				monitorProgress: function () {
					return deferred.promise;
				}
			};
		}

		function createAssetAsync(fileId, uploadedFile, operations, cancellationToken) {
			return assetService.createAssetAsync(uploadedFile, operations, { cancellationToken: cancellationToken });
		}

		function updateAssetAsync(assetId, operations, cancellationToken) {
			return assetService.editAssetsAsync([ assetId ], operations, { cancellationToken: cancellationToken });
		}

		function uploadFilesAndCreateOrUpdateAssetsAsync(files, cancellationToken) {
			var progressTracker = createProgressTracker();
			var deferred = $q.defer();
			var uploads = [];
			var uploadId;

			if (cancellationToken) {
				cancellationToken.whenCanceled(function () {
					deferred.reject('abort');
				});
			}

			fileUploadService.getFileBatchUploadIdAsync()
				.then(function(batchId) {
					var index = 0;
					uploadId = batchId;

					// read file size to calculate totals for progress meter
					// async to avoid blocking the UI
					return promiseUtilityService.forEachAsync(files, function(file) {
						var fileId = index++;

						progressTracker.addFile(fileId, file.file.size);
						progressTracker.setFileStatus(fileId, 'uploading');

						uploads.push({ id: fileId, file: file.file, operations: file.operations, assetId: file.assetId });
					}, cancellationToken);
				})
				.then(function () {
					// upload files and create assets in parallel
					return promiseUtilityService
						.parallelForEach(uploads, { maxDegreeOfParallelism: 2, cancellationToken: cancellationToken }, function (upload) {
							var fileId = upload.id;
							var file = upload.file;
							var assetId = upload.assetId;

							log.info('Uploading file ' + fileId);

							// upload file
							return fileUploadService.uploadFileAsync(file, cancellationToken)
								.then(function (uploadedFile) {
										var operations = upload.operations;
										operations.unshift({ op: 'setFile', fileId: uploadedFile.id, update: true });
										operations.push({ op: 'setMetadata', path: 'uploadId', value: uploadId });

										if (assetId) {
											// update asset
											log.info('Updating asset for file ' + fileId);
											return updateAssetAsync(assetId, operations, cancellationToken);
										}
										else {
											// create asset
											log.info('Creating asset for file ' + fileId);
											return createAssetAsync(fileId, uploadedFile, operations, cancellationToken);
										}
									},
									null,
									function (fileUploadProgress) {
										progressTracker.setUploadProgress(fileId, fileUploadProgress.loaded, fileUploadProgress.total);
									}
								)
								.then(function(job) {
									// report file completed
									progressTracker.setUploadProgress(fileId, file.size, file.size);
									progressTracker.setFileStatus(fileId, 'complete');
									return {
										job: job,
										file: file
									};
								})
								.catch(function (error) {
									// report file error
									log.warn('Error uploading file ' + fileId + ': ' + error);
									progressTracker.setFileStatus(fileId, 'error');
									return {
										error: error || 'unknown error',
										file: file
									};
								});
						}, cancellationToken);
				})
				.then(function (result) {
					// upload batch complete
					log.info('Batch upload complete.');
					deferred.resolve({
						jobs: result,
						batchId: uploadId
					});
				});

			progressTracker.monitorProgress()
				.then(null, null, function (progress) {
					deferred.notify(progress);
				});

			return deferred.promise;
		}

		function uploadFilesAndCreateAssetsAsync(files, cancellationToken) {
			return uploadFilesAndCreateOrUpdateAssetsAsync(files, cancellationToken);
		}

		return {
			uploadFilesAndCreateAssetsAsync: uploadFilesAndCreateAssetsAsync,
			uploadFilesAndCreateOrUpdateAssetsAsync: uploadFilesAndCreateOrUpdateAssetsAsync
		};
	}
	fileUploadManager.$inject = ['$q', '$log', 'assetService', 'fileUploadService', 'cancellationService', 'promiseUtilityService', '_'];
})();